<template>
  <div class="order-list">
    <Toolbar :handle-add="() => addHandlerSub('Order',parentAdd)" v-if="userHasAccess('order_edit')">
      <template #left>
        <h1><v-icon large>mdi-basket</v-icon>{{$t('order.orders')}}</h1>
      </template>
    </Toolbar>
    <v-container>
      <v-layout row wrap>

        <v-flex lg12>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @click:row="showHandler"
@contextmenu:row="showHandlerExt"
            @update:options="onUpdateOptions"
          >
          <template slot="item.badge" slot-scope="{ item }">
              <v-tooltip bottom content-class="tooltip-light">
                <template v-slot:activator="{ on, attrs }">
                  <div v-on="on" class="ma-0 pa-0">
                    <v-badge inline center overlap dark v-bind="attrs"
                    :color="item.state.couleur">
                    </v-badge>
                  </div>
                </template>
                <span>{{item.state.name}}</span>
              </v-tooltip>
            </template>
          <template slot="item.ref" slot-scope="{ item }" >
              <span class="truncate">{{ item.ref }}</span>
            </template>
          <template slot="item.delivery" slot-scope="{ item }">
            {{ formatDateTime(item['delivery'], 'long') }}
          </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'OrderList',
  servicePrefix: 'Order',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
  },
  data() {
    return {
      headers: [
        { text: this.$t('order.state'), value: 'badge'},
        { text: this.$t('order.ref'), value: 'ref' },
        { text: this.$t('customer.customer'), value: 'customer.name' },
        { text: this.$t('order.quantity'), value: 'quantity' },
        { text: this.$t('order.material'), value: 'material' },
        { text: this.$t('order.delivery'), value: 'delivery' },
      ],
  selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['created'], sortDesc : [true]},
      filters: {
        'designFile' : this.$route.params.id,
      },
      parentAdd: {
        '@id' : this.$route.params.id,
      }
    };
  },
  computed: {
    ...mapGetters('order', {
      items: 'list'
    }),
    ...mapFields('order', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('order', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),
  }
};
</script>
<style>
    .truncate {
      max-width: 100px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
    }
</style>